export default __webpack_public_path__ + "static/media/carvana-coverage-shield.cb119056.svg";